import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleExclamation, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import '../../assets/styles.css';
import JsonTable from "./JsonTable";

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function NoteTypeImage(item) {
  const hasErrors = Object.keys(item.node['errors'] || {}).length > 0;
  const hasWarnings = Object.keys(item.node['warnings'] || {}).length > 0;

  if (hasErrors) {
    return (
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="text-red-500 mr-1 pt-1"
        title="Error"
        size="lg"
      />
    );
  } else if (hasWarnings) {
    return (
      <FontAwesomeIcon
        icon={faCircleExclamation}
        className="text-yellow-500 mr-1 pt-1"
        title="Warning"
        size="lg"
      />
    );
  } else {
    return (
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="text-green-500 mr-1 pt-1"
        title="Success"
        size="lg"
      />
    );
  }
}

function JsonNode({ data, name, topLevel }) {
  const [collapsed, setCollapsed] = useState(true);
  const isObject = typeof data === "object" && data !== null;

  if (!isObject && topLevel) {
    return (
      <div className="pl-8 pb-1">
        {capitalize(name)}: {String(data)}
      </div>
    );
  }

  if (!isObject) {
    return (
      <div className="pl-7 pb-1">
        <strong>{name}:</strong> {String(data)}
      </div>
    );
  }

  const entries = Object.entries(data);

  return (
    <li className="pl-2">
      { entries.length === 0 &&
        <div className="pl-6 pb-1">
          {capitalize(name)}: 0
        </div>  

      }
      { entries.length > 0 &&
        <div className="">
          <div className="flex" style={{ cursor: "pointer" }} onClick={() => setCollapsed(!collapsed)} >
            { topLevel === 0 ? (
              <NoteTypeImage node={data} />
            ) : (
              <div className="pl-5 flex">
                <span className={`transform transition-transform ${!collapsed ? "rotate-90" : ""}`} >            
                  ▶ 
                </span>
              </div>
            ) }
            <p className="pl-1 pb-1">
              {capitalize(name)}
              { topLevel === 1 && `: ${entries.length}` }
            </p>
          </div>
        </div>
      }

      {!collapsed && topLevel < 3 &&
        entries.map(([key, value]) => (
          <JsonNode
            key={key}
            name={key}
            data={value}
            topLevel={topLevel + 1}
          />
        ))}
      {!collapsed && topLevel === 3 &&
          <JsonTable data={data} />
        }

    </li>
  );
}

const TreeView = ({ data, filter, onItemSelect }) => {
  const [selectedId, setSelectedId] = useState(null);
  const [dataToRender, setDataToRender] = useState(data);

  useEffect(() => {
    const filteredData = (data) => {
      if (!filter || filter === 'All' || filter === '') {
        return data;
      } 

      const result = {};
      Object.entries(data).map(([key, value]) => {
      if (value) {
        const cd = Object.keys(value.errors || {}).length || 0;
        const fd = Object.keys(value.warnings || {}).length || 0;
        const bd = Object.keys(value.success || {}).length || 0;
        if (filter === 'Errors' && cd > 0) {
          result[key] = data[key];
        } else if (filter === 'Warnings' && fd > 0 && cd === 0) {
          result[key] = data[key];
        } else if (filter === 'Success' && bd > 0 && cd === 0 && fd === 0) {
          result[key] = data[key];
        } 
      }
    });

    return result;
    };
    setDataToRender(filteredData(data));
  }, [data, filter]);


  return (
    <ul className="list-none pt-1">
      {dataToRender ? Object.keys(dataToRender).map((node, idx) => (
        <JsonNode key={idx} name={node} data={dataToRender[node]} topLevel={0} />
      )) : null}
    </ul>
  );
};

export default TreeView;
